import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";

export default function MpgsResponse({ htmlContent, isOpen, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered={true}
      size="full"
      blockScrollOnMount={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody className="flex items-center justify-center">
          <iframe
            srcDoc={htmlContent}
            frameborder="0"
            loading="eager"
            title="3D Secure Authentication"
            className="h-screen w-full"
          ></iframe>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

MpgsResponse.propTypes = {
  htmlContent: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
